/* @flow */

import { type Charge } from './types';
import { type Pedido } from '../pedidos/types';
import traduzirFormaPagamento from './traduzirFormaPagamento';

const getChargeDoPedido = (pedido: Pedido): ?Charge => {
    const method = traduzirFormaPagamento(pedido);
    if (!method) {
        return null;
    }

    return {
        value: String(pedido.valor),
        method,
        change: String(pedido.troco),
    };
};

export default getChargeDoPedido;
